import type { IPromptCreatedNotificationData } from "@frontend-shared/types";
import { MessageSquareText } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IPromptCreatedCardProps {
  uuid: string;
  data: IPromptCreatedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewPrompts: (projectUuid: string) => void;
}

const PromptCreatedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewPrompts,
}: IPromptCreatedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewPrompts = useCallback(
    () => onViewPrompts(data.projectUuid),
    [onViewPrompts, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="prompt_created"
      createdAt={createdAt}
      isRead={isRead}
      icon={<MessageSquareText className="h-5 w-5 text-amber-500" />}
      iconBgClassName="bg-amber-500/10"
      ctaLabel={t("view_prompts")}
      onCtaClick={handleViewPrompts}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.prompt_created.body"
          values={{
            creatorName: data.creatorName,
            promptTitle: data.promptTitle,
            folderName: data.folderName,
            projectTitle: data.projectTitle,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const PromptCreatedCard = memo(PromptCreatedCardComponent);
